import React from 'react';
import PropTypes from 'prop-types';
import UseStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import Popover from '../Popover';
import Budget from '../Budget';
import Input from '../../elements/Input';
import CheckList from '../CheckList';
import Header from '../../elements/Header';
import Box from '../../elements/Box';
import Button from '../../elements/Button';
import { strFormat } from '../../../helpers/utils';

class AirBnBMoreFilters extends React.Component {
  state = {
    budget: this.props.defaultBudget,
    homeType: this.props.defaultHomeType,
    budgetDraft: this.props.defaultBudget,
    homeTypeDraft: this.props.defaultHomeType
  };

  constructor(props) {
    super(props);
    props.focusReferences(this);
  }

  onChange = () => {
    const { onChange } = this.props;
    const { budget, homeType, budgetDraft, homeTypeDraft } = this.state;
    if (budgetDraft !== budget || homeTypeDraft !== homeType) {
      this.setState({ budget: budgetDraft, homeType: homeTypeDraft }, () => {
        onChange({ budget: budgetDraft, homeType: homeTypeDraft });
      });
    }
  };

  saveAndClose = () => {
    this.popover.closePopover();
    this.onChange();
  };

  onBudgetChange = (budgetDraft) => {
    this.setState({ budgetDraft });
  };

  onHomeTypeChange = (homeTypeDraft) => {
    this.setState({ homeTypeDraft });
  };

  reset = () => {
    this.setState({ budgetDraft: '', homeTypeDraft: [] }, () => {
      if (this.budget) {
        this.budget.reset();
      }
    });
  };

  onClear = () => {
    const { onClear } = this.props;
    this.reset();
    onClear();
  };

  renderInputElement = () => {
    const { inputItem } = this.props;
    const { translate, direction, theme } = this.context;
    const { homeTypeDraft, budgetDraft } = this.state;
    const [className] = UseStyles(this.props, { direction, theme });
    const selectedFilters = homeTypeDraft.length + (budgetDraft ? 1 : 0);
    let mainInputValue = '';
    if (selectedFilters > 0) {
      mainInputValue = strFormat(
        translate('cmp-airbnb-more-filters-label', 'More filters ({0} selected)'),
        [selectedFilters]
      );
    }

    return (
      <Input
        {...inputItem}
        leftIcons={['settings']}
        leftTabIndex={[-1]}
        value={mainInputValue}
        placeholder={translate('cmp-airbnb-more-filters-placeholder', 'More Filters')}
        label={translate(`cmp-airbnb-more-filters-label-key`, 'More Filters')}
        className={className}
      />
    );
  };

  render = () => {
    const {
      popoverItem,
      titleSettings,
      budget: budgetSettings,
      homeTypeSettings,
      clearButton,
      applyButton
    } = this.props;
    const { budgetDraft, homeTypeDraft } = this.state;
    const { translate } = this.context;
    const selectedFilters = homeTypeDraft.length + budgetDraft ? 1 : 0;

    return (
      <Popover
        alignLeft
        {...popoverItem}
        element={this.renderInputElement()}
        onClose={this.onChange}
        focusReferences={(ref) => {
          this.popover = ref;
        }}
      >
        <Header
          textAlign="left"
          {...titleSettings}
          tag="h6"
          content={translate('cmp-airbnb-more-budget-title', 'Budget')}
        />
        <Budget
          {...budgetSettings}
          defaultValue={budgetDraft}
          onClear={this.onBudgetChange}
          onChange={this.onBudgetChange}
          focusReferences={(ref) => {
            this.budget = ref;
          }}
        />
        <CheckList onChange={this.onHomeTypeChange} value={homeTypeDraft} {...homeTypeSettings} />
        <Box className="fr-clearfix">
          {selectedFilters > 0 && (
            <Button color="none" floatLeft onClick={this.onClear} paddingWidth="0" {...clearButton}>
              {translate('cmp-airbnb-filters-clear-button', 'Clear')}
            </Button>
          )}
          <Button
            color="none"
            paddingWidth="0"
            borderColor="white"
            textColor="primary"
            floatRight
            onClick={this.saveAndClose}
            {...applyButton}
          >
            {translate('cmp-airbnb-filters-apply-button', 'Apply')}
          </Button>
        </Box>
      </Popover>
    );
  };
}

AirBnBMoreFilters.propTypes = {
  /**
   * Props of the popover
   */
  popoverItem: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of the budget
   */
  budget: PropTypes.objectOf(PropTypes.any),
  /**
   * Fires whe aply button is pressed
   */
  onChange: PropTypes.func,
  /**
   * Default budget value for filter
   */
  defaultBudget: PropTypes.string,
  /**
   * Default home type value for filter
   */
  defaultHomeType: PropTypes.arrayOf(PropTypes.string),
  focusReferences: PropTypes.func,
  onClear: PropTypes.func,
  className: PropTypes.string,
  inputItem: PropTypes.objectOf(PropTypes.any),
  titleSettings: PropTypes.objectOf(PropTypes.any),
  homeTypeSettings: PropTypes.objectOf(PropTypes.any),
  clearButton: PropTypes.objectOf(PropTypes.any),
  applyButton: PropTypes.objectOf(PropTypes.any)
};
AirBnBMoreFilters.defaultProps = {
  popoverItem: {},
  budget: {},
  onChange: () => {},
  defaultBudget: '',
  defaultHomeType: [],
  focusReferences: () => {},
  onClear: () => {},
  className: null,
  inputItem: {},
  titleSettings: {
    fontWeight: 'bold',
    fontSize: '14px'
  },
  homeTypeSettings: {},
  clearButton: {},
  applyButton: {}
};

AirBnBMoreFilters.contextType = Context;

AirBnBMoreFilters.componentName = 'AirBnBMoreFilters';

export default AirBnBMoreFilters;
